<!--  -->
<template>
  <div class="home">
    <!--  <div class="nav">
      导航条 
      <el-menu mode="horizontal">
        <el-menu-item v-for="(item, index) in navList" :key="index">
          <a :href="item.link" target="_blank">{{ item.name }}</a>
        </el-menu-item>
      </el-menu>
      <el-button type="info" class="login" @click="openLogin()">登录</el-button>
    </div>-->
    <multi :class="change ? 'bgactive2' : 'bgactive1'" :inp="!change"></multi>
    <div class="searchbox active1">
      <div class="search" ref="pronbit">
        <!--<div class="swiperBtn" v-show="change">
          <div class="swiper-button-prev"></div>
          左箭头。如果放置在swiper-container外面，需要自定义样式
        <div class="swiper-button-next"></div>
          右箭头。如果放置在swiper-container外面，需要自定义样式
        </div>-->
        <div style="background:#fff;border-radius: 6px;">
          <el-select v-model="toWhere" placeholder="请选择" @change="activeName = String(toWhere)">
            <el-option
              v-for="item in infoOrTender"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            ></el-option>
          </el-select>
          <el-divider direction="vertical"></el-divider>
          <el-input placeholder="请输入内容" v-model="search" class="input-with-select" clearable>
            <el-button class="btn" slot="append" icon="el-icon-search" @click="gotoFind()"></el-button>
          </el-input>
        </div>
        <ul class="tabList">
          <li>热门招标搜索：</li>
          <li
            class="bottomLine"
            v-for="(item, index) in topHot"
            :key="index"
            @click="hotgotoFind(item)"
          >{{ item }}</li>
          <li class="more bottomLine" @click="gotoFind()">高级搜索></li>
        </ul>
      </div>
    </div>
    <!-- 轮播图 -->
    <img class="seo" src="../assets/qxchuhai1.jpeg" alt="牵星出海" />
    <img class="seo" src="../assets/qxchuhai2.jpeg" alt="牵星出海" />
    <swiper v-if="sliderList.length > 0" ref="mySwiper" :options="swiperOption">
      <swiper-slide
        v-for="(item, index) in sliderList"
        :key="index"
        :style="
          `background: url('${item.topimg}') no-repeat
        center center;
      background-size: 100% 100%;`
        "
      >
        <div class="mask" :style="{
            opacity: `${progress}`,
          }"></div>
        <div class="swiperTxt">
          <p class="txt1">
            {{ item.maintitle }}
            <button
              v-if="item.type == '1'"
              class="goto"
              @click="countrygotoFind(item.value)"
            >
              等你来发现
              <i class="el-icon-right"></i>
            </button>
          </p>
          <p class="txt2">{{ item.title }}</p>
        </div>
      </swiper-slide>
    </swiper>
    <!-- mouse  -->
    <!-- <i class="mouse el-icon-mouse"></i> -->
    <img class="mouse" src="../assets/mouse.png" alt />
    <!-- <p class="numInfo">{{ num }}条招标信息</p> -->
    <div class="content">
      <el-tabs v-model="activeName" type="card" @tab-click="handleTab">
        <el-tab-pane label="全球24小时招标信息热门榜" name="1">
          <span slot="label">
            <i class="icon1"></i>
            <div class="tabName">
              <p style="font-size:16px;">全球24小时招标信息热门榜</p>
              <p style="font-size:14px;">热门招商信息一手掌握</p>
            </div>
          </span>
          <ul class="tagList">
            <li
              v-for="(item, index) in tagList"
              :key="index"
              :class="activeIndex == index ? 'active' : ''"
              @click="tag(item, index)"
            >{{ item }}</li>
          </ul>
          <ul class="infoList">
            <li
              v-for="(item, index) in infoList"
              :key="index"
              @mouseenter="mouseEnter(index)"
              @mouseleave="mouseLeave"
              :class="{ shadow: index == isActive }"
            >
              <p class="title1" @click="gotoDetail(item.bidid)">{{ item.othertitle }}</p>
              <p class="title2" @click="gotoDetail(item.bidid)">{{ item.chinesetitle }}</p>
              <p class="info">
                <span v-if="item.didcustomer != null">customer：{{ item.didcustomer }}</span>
                <span>发布日期：{{ item.reletime }}</span>
              </p>
              <p class="tagGroup">
                <span
                  @click="countrygotoFind(item.countrgions)"
                  class="country"
                  v-if="item.nationalFlag"
                >
                  {{ item.nationalFlag.chinesecountry }}
                  <img
                    v-if="item.nationalFlag"
                    alt
                    :src="
                      `http://182.61.21.235/images/${item.nationalFlag.nfaddress}`
                    "
                  />
                </span>
                <span v-else>暂无地区信息</span>
                <el-tag v-if="item.labelo" @click="hotgotoFind(item.labelo)">
                  {{
                  item.labelo
                  }}
                </el-tag>
                <el-tag v-if="item.labelt" @click="hotgotoFind(item.labelt)">
                  {{
                  item.labelt
                  }}
                </el-tag>
                <el-tag v-if="item.lables" @click="hotgotoFind(item.lables)">
                  {{
                  item.lables
                  }}
                </el-tag>
                <el-tag
                  type="danger"
                  v-if="item.didbudget"
                  @click="hotgotoFind(item.didbudget)"
                >{{ item.didbudget }}</el-tag>
                <el-tag
                  type="danger"
                  v-if="item.didnotice"
                  @click="hotgotoFind(item.didnotice)"
                >{{ item.didnotice }}</el-tag>
                <span class="kbrq" v-if="item.starttime != '' && item.starttime != null">
                  <i class="el-icon-time"></i>
                  开标日期：{{
                  item.deadline
                  }}
                </span>
              </p>
            </li>
          </ul>
          <p class="more" @click="gotoFind()">查看更多></p>
        </el-tab-pane>
        <el-tab-pane label="全球24小时热点行业资讯榜" name="2">
          <span slot="label">
            <i class="icon2"></i>
            <div class="tabName">
              <p style="font-size:16px;">全球24小时热点行业资讯榜</p>
              <p style="font-size:14px;">快速了解世界大事小情</p>
            </div>
          </span>
          <ul class="tagList">
            <li
              v-for="(item, index) in zxtagList"
              :key="index"
              :class="zxActiveIndex == index ? 'active' : ''"
              @click="getAdvhost(item, index)"
            >{{ item }}</li>
          </ul>
          <ul class="hotList">
            <li v-for="(item, index) in hotList" :key="index" @click="toInfoDetail(item.id)">
              <i
                class="serial"
                :class="
                  index == 0 ? 'st' : index == 1 ? 'nd' : index == 2 ? 'rd' : ''
                "
              >{{ index + 1 }}</i>
              <span class="title">
                {{
                item.translationtitle
                ? item.translationtitle
                : item.originaltitle
                }}
              </span>
              <span class="country">
                <span class="left">{{ item.advcountry }}</span>
                <img
                  v-if="item.countryname"
                  :src="`http://182.61.21.235/images/${item.countryname}`"
                  alt
                />
                <!-- <span class="right">{{ item.calorific }}</span> -->
              </span>
              <!-- <img
                class="arrow"
                :src="
                  item.thanbefore == 2
                    ? up
                    : item.thanbefore == 0
                    ? down
                    : equal
                "
                alt=""
              />-->
            </li>
          </ul>
          <p class="more" @click="gotoFind()">查看更多></p>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="countryBox">
      <div class="countryList">
        <h4>全球招标信息一站收集</h4>
        <ul>
          <li
            v-for="(item, index) in countryList"
            :key="index"
            @click="countrygotoFind(item.countrgions)"
          >
            <span class="left" v-if="item.nationalFlag">{{ item.nationalFlag.chinesecountry }}</span>
            <img
              :src="
                `http://182.61.21.235/images/${item.nationalFlag.nfaddress}`
              "
              alt
              v-if="item.nationalFlag"
            />
            <span class="right" v-if="item.nationalFlag">{{ item.bidcount }}</span>
          </li>
        </ul>
        <button class="allCountry" @click="gotoCountry()">
          查看全部国家
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>
    <!-- <login :visible.sync="dialogFormVisible"></login> -->
    <about></about>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
//import login from '../components/login.vue'
import multi from '../components/header.vue'
import about from '../components/footer.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'home',
  components: { multi, about },
  data() {
    //这里存放数据
    return {
      toWhere: 1, //选择去资讯还是招标
      infoOrTender: [
        { id: 1, value: '招标' },
        { id: 2, value: '资讯' },
      ],
      up: require('../assets/up.png'),
      down: require('../assets/down.png'),
      equal: require('../assets/equal.png'),
      dialogFormVisible: false, //登录框显示or隐藏
      search: '', //搜索框内容
      progress: 0, //透明度
      change: true, //变化搜索框样式的标识
      num: 345622, //招标信息数
      activeName: '1',
      activeIndex: 0, //tag列表样式
      zxActiveIndex: 0,
      swiperOption1: {
        loop: true,
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'my-button-disabled',
        },

        observer: true, // 动态检查器,自动初始化swiper,默认为false
        observerParents: true,

        // Some Swiper option/callback...
      },
      swiperOption2: {
        pagination: {
          el: '.swiper-pagination',
        },
        autoplay: false,
        loop: false,
      },
      countryList: [],
      hotList: [],
      infoList: [],
      tagList: [],
      zxtagList: [],
      navList: [
        {
          name: '首页',
          link: '',
        },
        {
          name: '行业舆情',
          link: '',
        },
        {
          name: '招标订阅',
          link: '',
        },
        {
          name: '招标搜索',
          link: '',
        },
        {
          name: '数据导出',
          link: '',
        },
        {
          name: '增值服务',
          link: '',
        },
      ],
      sliderList: [],
      topHot: [],
      isActive: false,
    }
  },
  //监听属性 类似于data概念
  computed: {
    swiperOption() {
      var len = this.sliderList.length
      if (len == 1) {
        return this.swiperOption2
      } else {
        return this.swiperOption1
      }
      // return this.$refs.mySwiper.$swiper
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleTab(tab) {
      this.toWhere = Number(this.activeName)
      if (tab.index == '1') {
        this.advList()
      }
    },
    getAdvhost(name, index) {
      this.zxActiveIndex = index
      if (name == '全部') {
        this.advList()
      } else {
        let params = {
          lable: name,
        }
        this.axios
          .get(API_1 + Global.advhost, { params: params })
          .then((res) => {
            this.hotList = res.data.data
          })
          .catch((res) => {})
      }
    },
    toInfoDetail(id) {
      this.$router.push({
        path: '/info',
        query: {
          id: id,
        },
      })
    },
    mouseEnter(index) {
      this.isActive = index
    },
    mouseLeave() {
      this.isActive = null
    },
    hotgotoFind(val) {
      //跳转搜索页
      //跳转详情页
      const { href } = this.$router.resolve({
        path: `find`,
        query: { lable: val },
      })
      window.open(href, '_blank')
    },
    countrygotoFind(val) {
      //跳转搜索页
      const { href } = this.$router.resolve({
        path: `find`,
        query: { country: val },
      })
      window.open(href, '_blank')
    },
    gotoCountry() {
      //跳转搜索页
      //跳转搜索页
      const { href } = this.$router.resolve({
        path: `allCountry`,
      })
      window.open(href, '_blank')
    },
    openLogin() {
      this.dialogFormVisible = true
    },
    infoTag() {
      //热门招标信息筛选标签
      let params = {}
      this.axios
        .get(API_1 + Global.hotTag, { params: params })
        .then((res) => {
          this.tagList = res.data['button']
        })
        .catch((res) => {})
      //热门资讯筛选标签
      this.axios
        .get(API_1 + Global.zixunhot, { params: params })
        .then((res) => {
          this.zxtagList = res.data.zixunbutton
        })
        .catch((res) => {})
    },
    getCountry() {
      //底部国家列表
      let params = {}
      this.axios
        .get(API_1 + Global.homeCountry, { params: params })
        .then((res) => {
          this.countryList = res.data.data
        })
        .catch((res) => {})
    },
    swiperList() {
      //轮播图
      let params = {}
      this.axios
        .get(API_1 + Global.swiper, { params: params })
        .then((res) => {
          this.sliderList = res.data.data
        })
        .catch((res) => {})
    },
    gotoFind(val) {
      //跳转搜索页
      if (this.toWhere == 2) {
        //资讯
        const { href } = this.$router.resolve({
          path: `findInfo`,
          query: { keyWord: this.search },
        })
        window.open(href, '_blank')
      } else {
        //招标
        const { href } = this.$router.resolve({
          path: `find`,
          query: { keyWord: this.search },
        })
        window.open(href, '_blank')
      }

      // this.$router.push({
      //   path: 'find',
      //   query: { keyWord: this.search },
      // })
    },
    gotoDetail(id) {
      //跳转搜索页
      const { href } = this.$router.resolve({
        path: `detail`,
        query: { id: id },
      })
      window.open(href, '_blank')
    },
    advList() {
      let params = {}
      this.axios
        .get(API_1 + Global.hotInfo, { params: params })
        .then((res) => {
          this.hotList = res.data.data
        })
        .catch((res) => {})
    },
    topList() {
      //5条招标信息
      let params = {}
      this.axios
        .get(API_1 + Global.topInfo, { params: params })
        .then((res) => {
          this.infoList = res.data.data
        })
        .catch((res) => {})
    },
    tag(name, index) {
      //标签切换
      this.activeIndex = index
      if (name == '全部') {
        this.topList()
      } else {
        let params = {
          lable: name,
        }
        this.axios
          .get(API_1 + Global.getHot, { params: params })
          .then((res) => {
            this.infoList = res.data.data
          })
          .catch((res) => {})
      }
    },
    handleScroll() {
      let screenHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      let top = this.$refs.pronbit.getBoundingClientRect().top
      if (top > 0) {
        this.progress = 0.5 - top / 120 / 2
      } else {
        this.progress = 0.6
      }
      let sss =
        document.documentElement.clientHeight || document.body.clientHeight

      if (screenHeight > sss / 2 - 100) {
        //420 280
        this.change = false
      }
      if (screenHeight < sss / 2 - 100) {
        this.change = true
      }
      if (screenHeight <= 0) {
        this.progress = 0
      }
    },
    getTopHot() {
      //搜索下热词
      let params = {}
      this.axios
        .get(API_1 + Global.topHot, { params: params })
        .then((res) => {
          this.topHot = res.data.hostsou
        })
        .catch((res) => {})
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //this.advList()
    this.topList()
    this.swiperList()
    this.getCountry()
    this.infoTag()
    this.getTopHot()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮滚动事件
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true)
  }, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss">
  .el-select-dropdown__item.selected {
    color: #0f72b7 !important;
  }
</style>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .shadow {
    box-shadow: #0f72b7 0px 0px 18px;
    background: #fff !important;
  }
  .swiper-container {
    height: 100%;
    margin: 0 auto;
    width: 100%;
    .swiper-wrapper {
      .swiper-slide {
        img {
          margin: 0 auto;
          width: 100%;
          min-width: 1200px;
          //min-height: 933px;
        }
      }
    }
  }

  .swiperTxt {
    position: absolute;
    top: 30%;
    left: 0;
    color: #fff;
    width: 100%;
    text-align: left;
    .txt1 {
      width: 920px;
      margin: 0 auto;
      font-size: 50px;
      position: relative;
      font-weight: bold;
      .goto {
        color: #fff;
        width: 200px;
        height: 50px;
        background: transparent;
        border: 1px solid #fff;
        font-size: 18px;
        position: absolute;
        top: 12vh;
        left: 0;
        cursor: pointer;
      }
    }
    .txt2 {
      width: 920px;
      margin: 2vh auto 0;
      font-size: 28px;
    }
  }

  .icon1 {
    background: url('../assets/tac1.png') no-repeat center center;
    background-size: auto 100%;
    width: 41px;
    height: 41px;
    display: inline-block;
    vertical-align: middle;
  }
  .icon2 {
    background: url('../assets/tac2.png') no-repeat center center;
    background-size: auto 100%;
    width: 41px;
    height: 41px;
    display: inline-block;
    vertical-align: middle;
  }
  .tabName {
    vertical-align: middle;
    display: inline-block;
    margin-left: 10px;
    p {
      line-height: 20px;
      text-align: left;
    }
  }

  /deep/ .infoList {
    width: 1000px;
    margin: 0 auto 30px;
    li {
      margin-top: 10px;
      height: 167px;
      border-radius: 6px;
      background: #eff4f8;
      padding: 15px 40px;
      text-align: left;
      box-sizing: border-box;
      &:hover {
        .title1,
        .title2 {
          color: #0f4d72;
        }
      }
      .title1,
      .title2 {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 800px;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        color: #0f4d72;
        cursor: pointer;
        color: #666;
      }
      .title2 {
        font-weight: inherit;
        margin-bottom: 20px;
      }
      .info {
        font-size: 12px;
        color: #999;
        margin-bottom: 20px;
        span {
          margin-right: 50px;
        }
      }
      .tagGroup {
        font-size: 12px;
        cursor: pointer;
        .el-tag {
          margin-left: 20px;
          color: #0f4d72;
          background: rgba(15, 77, 114, 0.1);
          height: 24px;
          line-height: 21px;
          border: 0;
        }
        .country {
          img {
            width: 34px;
            height: 20px;
            margin-left: 10px;
            border: 1px solid #dcdcdc;
          }
        }
        .kbrq {
          font-size: 14px;
          float: right;
          color: #0f4d72;
        }
      }
    }
  }
  /deep/.hotList {
    width: 1000px;
    margin: 0 auto;
    li {
      margin-top: 10px;
      height: 40px;
      border-radius: 6px;
      background: #eff4f8;
      padding: 15px 20px;
      text-align: left;
      line-height: 40px;
      cursor: pointer;
      vertical-align: middle;
      &:hover {
        box-shadow: #0f72b7 0px 0px 18px;
        background: #fff !important;
        .title1 {
          color: #0f4d72;
        }
      }
      .country {
        //width: 300px;
        display: inline-block;
        margin-left: 150px;
        // width: 150px;
        width: 215px;
        vertical-align: middle;
        text-align: right;
        img {
          width: 34px;
          height: 20px;
          margin-left: 10px;
          border: 1px solid #dcdcdc;
        }
        .left {
          // float: left;
          display: inline-block;
          text-align: right;
          // width: 100px;
          width: 160px;
        }
        .right {
          float: right;
          display: inline-block;
          text-align: left;
          width: 70px;
        }
      }
      .num {
        margin-left: 100px;
        vertical-align: middle;
      }
      .arrow {
        width: 12px;
        height: 15px;
        float: right;
        vertical-align: middle;
        vertical-align: -webkit-baseline-middle;
      }
      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        // width: 570px;
        width: 530px;
        font-size: 16px;
        font-weight: bold;
        color: #666;
        &:hover {
          color: #0f4d72;
        }
        display: inline-block;
        vertical-align: middle;
        margin-left: 10px;
      }
      .serial {
        border-radius: 50%;
        background: #7ea0b4;
        color: #fff;
        width: 30px;
        height: 30px;
        display: inline-block;
        line-height: 30px;
        text-align: center;
        vertical-align: middle;
      }
      .st {
        background: #d50000;
      }
      .nd {
        background: #ec761f;
      }
      .rd {
        background: #f6d72d;
      }
    }
  }
  .home {
    height: 100%;
    .bgactive1 {
      background: #2b3a47;
    }
    .bgactive2 {
      background: transparent;
    }
    .countryBox {
      color: #fff;
      padding-top: 50px;
      background-image: url('../assets/country.jpg');
      background-position: center center;
      background-repeat: no-repeat;
      background-color: #2b3a47;
      background-size: auto 100%;
      .countryList {
        width: 930px;
        margin: 0 auto;
        height: 500px;
        .allCountry {
          margin-top: 20px;
          color: #fff;
          background: transparent;
          width: 200px;
          height: 50px;
          border: 1px solid #fff;
          font-size: 16px;
          cursor: pointer;
          &:hover {
            // color: turquoise;
            // border: 1px solid turquoise;
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid transparent;
          }
        }
        h4 {
          margin-bottom: 20px;
        }
        ul {
          text-align: left;
          width: 930px;
          li {
            display: inline-block;
            margin-bottom: 30px;
            width: 230px;
            cursor: pointer;
            font-size: 14px;
            text-align: center;
            &:hover {
              .left {
                // color: turquoise;
                text-decoration: underline;
              }
              .right {
                text-decoration: underline;
              }
            }
            img {
              width: 35px;
              height: 20px;
            }
            .left {
              float: left;
              display: inline-block;
              text-align: right;
              width: 100px;
            }
            .right {
              float: right;
              display: inline-block;
              text-align: left;
              width: 70px;
            }
          }
        }
      }
    }
    .content {
      background: url('../assets/listbg.jpg') repeat-y top center;
      background-size: 100% auto;
      width: 100%;
      padding: 50px 0;
      /deep/ .el-tabs__header {
        margin: 0;
        border-bottom: none;
        color: #fff;
      }
      /deep/ .el-tabs__nav {
        background: transparent;
        border: none !important;
        float: none;
        width: 1000px;
        margin: 0 auto;
        text-align: left;
      }
      /deep/#tab-2 {
        left: -50px;
      }
      /deep/ .el-tabs__item {
        padding: 10px 20px;
        height: 65px;
        background: url('../assets/c2.png') no-repeat center left;
        background-size: 100% 100%;
        width: 400px;
        text-align: left;
        // border-radius: 0 20%/100px 100px 0 0;
        position: relative;
        border-left: none;
        color: #a4afb9;
      }
      /deep/.is-active {
        // border-bottom-color: #FFF;
        color: #12679a; //#0f4d72; //#409EFF
        background: url('../assets/c1.png') no-repeat center left;
        background-size: 100% 102%;
        font-size: 15px;
        z-index: 999;
        width: 400px;
        border-bottom-color: transparent !important;
        .icon1 {
          background: url('../assets/tab1.png') no-repeat center center;
        }
        .icon2 {
          background: url('../assets/tab2.png') no-repeat center center;
        }
      }
      .more {
        font-size: 16px;
        color: #0f4d72;
        width: 80px;
        margin: 20px auto 0;
        cursor: pointer;
        box-sizing: border-box;
        height: 25px;
        &:hover {
          color: #178cd1;
          //border-bottom: 1px solid #0f4d72;
        }
      }
      .tagList {
        padding: 15px 0px 15px 20px;
        text-align: left;
        background: #eff4f8;
        border-radius: 0 6px 6px 6px;
        width: 1000px;
        margin: 0 auto;
        box-sizing: border-box;
        li {
          display: inline-block;
          margin-right: 10px;
          background: #fff;
          font-size: 14px;
          padding: 6px 10px;
          border-radius: 6px;
          width: 100px;
          text-align: center;
          cursor: pointer;
          color: #999999;
          &:hover {
            background: #0f4d72;
            color: #fff;
          }
        }
        .active {
          background: #0f4d72;
          color: #fff;
        }
      }
      .el-tabs {
        // width: 1000px;
        //background: #eff4f8;
        margin: 0 auto;
        /deep/.el-tabs__content {
          //background: #eff4f8;
        }
      }
    }
    .numInfo {
      text-align: center;
      background: transparent;
      color: #fff;
      position: absolute;
      bottom: 13vh;
      left: 0;
      width: 100%;
      z-index: 9;
    }
    .mouse {
      text-align: center;
      background: transparent;
      color: #fff;
      position: absolute;
      // bottom: 18vh;
      bottom: 80px;
      left: 50%;

      margin-left: -21px;
      // width: 100%;
      z-index: 9;
      font-size: 30px;
      width: 21px;
      height: 36px;
      display: block;
      // animation: tada 2s linear 1s infinite alternate;
      // -webkit-animation: tada 2s linear 1s infinite alternate;
      // -moz-animation: tada 2s linear 1s infinite alternate;
    }
    @-webkit-keyframes tada {
      0% {
        -webkit-transform: scale(1);
      }
      10%,
      20% {
        -webkit-transform: scale(0.9) rotate(-3deg);
      }
      30%,
      50%,
      70%,
      90% {
        -webkit-transform: scale(1.1) rotate(3deg);
      }
      40%,
      60%,
      80% {
        -webkit-transform: scale(1.1) rotate(-3deg);
      }
      100% {
        -webkit-transform: scale(1) rotate(0);
      }
    }
    @-moz-keyframes tada {
      0% {
        -moz-transform: scale(1);
      }
      10%,
      20% {
        -moz-transform: scale(0.9) rotate(-3deg);
      }
      30%,
      50%,
      70%,
      90% {
        -moz-transform: scale(1.1) rotate(3deg);
      }
      40%,
      60%,
      80% {
        -moz-transform: scale(1.1) rotate(-3deg);
      }
      100% {
        -moz-transform: scale(1) rotate(0);
      }
    }
    @keyframes tada {
      0% {
        transform: scale(1);
      }
      10%,
      20% {
        transform: scale(0.9) rotate(-3deg);
      }
      30%,
      50%,
      70%,
      90% {
        transform: scale(1.1) rotate(3deg);
      }
      40%,
      60%,
      80% {
        transform: scale(1.1) rotate(-3deg);
      }
      100% {
        transform: scale(1) rotate(0);
      }
    }
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #000;
    }
    .active1 {
      //搜索框初始化定位样式
      position: absolute;
      top: 60%;
    }
    .active2 {
      //搜索框上移后样式
      position: fixed;
      top: 60px;
      background: #000;
    }
    .seo {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .searchbox {
      transform: translate(-50%, -50%);
      left: 50%;
      z-index: 99;
      width: 100%;
      height: 110px;
      padding-top: 10px;
      .search {
        width: 920px;
        margin: 0 auto;
        position: relative;
        /deep/ .el-divider--vertical {
          vertical-align: top;
          height: 60px;
        }
        /deep/ .el-input-group {
          width: 88%;
          .el-input__inner {
            border-color: transparent;
          }
          .el-input__inner:hover {
            border-color: transparent;
          }
        }
        /deep/.el-select {
          width: 10%;
          .el-input__inner {
            border-color: transparent;
          }
          /deep/.selected {
            color: #0f4d72;
          }
        }
        /deep/.el-input__inner:focus {
          // border-color: #0f4d72;
          border-color: transparent;
        }
        .el-button {
          &:hover {
            background: #105e8c;
          }
        }
        .tabList {
          text-align: left;
          color: #fff;
          margin-top: 15px;
          .bottomLine {
            &:hover {
              border-bottom: 1px solid #fff;
            }
          }
          li {
            display: inline-block;
            margin-right: 20px;
            cursor: pointer;
          }
          .more {
            float: right;
            margin-right: 0px;
            font-weight: bold;
          }
        }
        .swiperBtn {
          position: absolute;
          top: -30px;
          left: 40px;
          background: #000;
          /deep/ .my-button-disabled {
            opacity: 0.2;
          }
          .swiper-button-prev,
          .swiper-button-next {
            height: 30px;
            border: 1px solid #fff;
            border-radius: 50%;
            background: #fff;
            opacity: 1;
            &::after {
              font-size: 15px;
              color: rgb(155, 155, 155);
            }
          }
          .swiper-button-prev {
            left: -33px;
          }
          .swiper-button-next {
            left: 13px;
          }
        }
        /deep/.el-input__inner {
          height: 60px;
          font-size: 16px;
        }
        /deep/ .el-input-group__append {
          padding: 0 25px;
        }
        .btn {
          width: 45px;
          height: 45px;
          background: #0f4d72;
          color: #fff;
          padding: 8px 10px;
          margin: -8px -18px;
          /deep/i {
            font-size: 20px;
          }
        }
      }
    }
    .nav {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99999;
      width: 100%;
      background: transparent;
      border-bottom: solid 1px #e6e6e6;
      .el-button {
        background: transparent;
        margin-left: 50px;
      }
      .el-menu {
        background-color: transparent;
        width: 880px;
        border-bottom: none;
        display: inline-block;
        vertical-align: middle;
        .el-menu-item {
        }
      }
    }
  }
</style>
